import axios from '@axios'

// eslint-disable-next-line import/prefer-default-export
export default class CardServivice {
  addCardCustomer = data => new Promise((resolve, reject) => {
    axios.post('card/addCard', data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  getCardCustomer = () => new Promise((resolve, reject) => {
    axios.get('card/credit_cards')
      .then(resp => {
        resolve(resp)
      })
      .catch(err => {
        reject(err)
      })
  })

  deleteCardCustomer = idCard => new Promise((resolve, reject) => {
    axios.delete(`card/deleteCard/${idCard}`)
      .then(resp => {
        resolve(resp)
      })
      .catch(err => {
        reject(err)
      })
  })
}
